module.exports = "https://web-assets.ifttt.com/packs/media/subscriptions/ifttt_10ypromo_banner-f1facf4a.jpg";